var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "hpc-linear",
      class: [
        _vm.schema.settings.backgroundColor,
        "hpc-linear--block-count-" + _vm.blocksByShape.length,
        { "hpc-linear--background-image": _vm.schema.settings.backgroundImage }
      ],
      style: {
        "padding-top": _vm.schema.settings.marginTop + "px",
        "padding-bottom": _vm.schema.settings.marginBottom + "px",
        "background-image": _vm.schema.settings.backgroundImage
          ? "url(" + _vm.schema.settings.backgroundImage + ")"
          : "none"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "hpc-linear__content",
          class: [_vm.schema.settings.backgroundColor]
        },
        [
          _c("div", { staticClass: "container" }, [
            _vm.schema.settings.textAlignment.toLowerCase() === "center"
              ? _c("div", { staticClass: "row hpc-linear__header-bar" }, [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "h3 col-12-sm hpc-linear__header text-center",
                      class: [_vm.schema.settings.headerColor]
                    },
                    [_vm._v(_vm._s(_vm.schema.settings.sectionHeader))]
                  ),
                  _vm.schema.settings.shopAllLink
                    ? _c(
                        "div",
                        { staticClass: "col-12-sm text-center" },
                        [
                          _c(
                            "v-link",
                            {
                              staticClass: "hpc-linear__shop-all-block",
                              attrs: {
                                href: _vm.schema.settings.shopAllLink,
                                primary: ""
                              }
                            },
                            [_vm._v("Shop All")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _c(
                  "div",
                  {
                    staticClass:
                      "row hpc-linear__header-bar hpc-linear__side-by-side-container"
                  },
                  [
                    _c(
                      "h3",
                      {
                        staticClass: "h3 col-8-sm hpc-linear__header",
                        class: [_vm.schema.settings.headerColor]
                      },
                      [_vm._v(_vm._s(_vm.schema.settings.sectionHeader))]
                    ),
                    _vm.schema.settings.shopAllLink
                      ? _c(
                          "div",
                          { staticClass: "col-4-sm text-right" },
                          [
                            _c(
                              "v-link",
                              {
                                staticClass: "hpc-linear__shop-all-block",
                                attrs: {
                                  href: _vm.schema.settings.shopAllLink,
                                  primary: ""
                                }
                              },
                              [_vm._v("Shop All")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showStaticBlocks,
                  expression: "showStaticBlocks"
                }
              ],
              staticClass: "hpc-linear__blocks hpc-linear__blocks--static"
            },
            _vm._l(_vm.blocksByShape, function(block) {
              return block.settings.linear_image
                ? _c(
                    "a",
                    {
                      staticClass: "hpc-linear__block",
                      class: [
                        "hpc-linear__block--" + _vm.schema.settings.imageShape
                      ],
                      attrs: { href: block.settings.linear_link }
                    },
                    [
                      _c(
                        "figure",
                        {
                          staticClass: "hpc-linear__block-content",
                          class: {
                            "hpc-linear__block-content--rectangle bg-white":
                              _vm.schema.settings.imageShape === "rectangle"
                          }
                        },
                        [
                          _vm.schema.settings.imageShape === "square"
                            ? _c("img", {
                                attrs: {
                                  src: _vm.imageCrop(
                                    _vm.imageSize(
                                      block.settings.linear_image,
                                      "320x320"
                                    ),
                                    "center"
                                  ),
                                  srcset: _vm.srcsetSquare(
                                    block.settings.linear_image
                                  ),
                                  alt: ""
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "hpc-linear__block-image-wrapper"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.imageSize(
                                        block.settings.linear_image,
                                        "x256"
                                      ),
                                      srcset: _vm.srcsetRectangle(
                                        block.settings.linear_image
                                      ),
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                          _c(
                            "figcaption",
                            { staticClass: "h7 color-black text-center" },
                            [
                              _vm._v(
                                _vm._s(block.settings.linear_collection_name)
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showStaticBlocks,
                  expression: "!showStaticBlocks"
                }
              ],
              staticClass: "hpc-linear__blocks hpc-linear__blocks--swiper"
            },
            [
              _vm.blocksByShape.length > 4
                ? _c(
                    "swiper",
                    {
                      class: {
                        "u-hidden-mobile-only":
                          _vm.schema.settings.imageShape === "rectangle"
                      },
                      attrs: { options: _vm.swiperOptions }
                    },
                    [
                      _c("div", {
                        staticClass:
                          "hpc-linear__pagination hpc-linear__pagination--desktop",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      }),
                      _vm._l(_vm.blocksByShape, function(block) {
                        return _c(
                          "swiper-slide",
                          {
                            key:
                              block.settings.linear_link +
                              block.settings.linear_image,
                            class: [
                              "swiper-slide--" + _vm.schema.settings.imageShape
                            ]
                          },
                          [
                            block.settings.linear_image
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "hpc-linear__block",
                                    class: [
                                      "hpc-linear__block--" +
                                        _vm.schema.settings.imageShape
                                    ],
                                    attrs: { href: block.settings.linear_link }
                                  },
                                  [
                                    _c(
                                      "figure",
                                      {
                                        staticClass:
                                          "hpc-linear__block-content",
                                        class: {
                                          "hpc-linear__block-content--rectangle bg-white":
                                            _vm.schema.settings.imageShape ===
                                            "rectangle"
                                        }
                                      },
                                      [
                                        _vm.schema.settings.imageShape ===
                                        "square"
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.imageCrop(
                                                  _vm.imageSize(
                                                    block.settings.linear_image,
                                                    "320x320"
                                                  ),
                                                  "center"
                                                ),
                                                srcset: _vm.srcsetSquare(
                                                  block.settings.linear_image
                                                ),
                                                alt: ""
                                              }
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "hpc-linear__block-image-wrapper"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.imageSize(
                                                      block.settings
                                                        .linear_image,
                                                      "x256"
                                                    ),
                                                    srcset: _vm.srcsetRectangle(
                                                      block.settings
                                                        .linear_image
                                                    ),
                                                    alt: ""
                                                  }
                                                })
                                              ]
                                            ),
                                        _c(
                                          "figcaption",
                                          {
                                            staticClass:
                                              "h7 color-black text-center"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                block.settings
                                                  .linear_collection_name
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.schema.settings.imageShape === "rectangle"
                ? _c(
                    "swiper",
                    {
                      staticClass: "u-hidden-tablet-up",
                      attrs: { options: _vm.swiperOptionsMobile }
                    },
                    [
                      _c("div", {
                        staticClass:
                          "hpc-linear__pagination hpc-linear__pagination--mobile",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      }),
                      _vm._l(_vm.blocksByShape, function(block) {
                        return _c(
                          "swiper-slide",
                          {
                            key:
                              block.settings.linear_link +
                              block.settings.linear_image,
                            class: [
                              "swiper-slide--" + _vm.schema.settings.imageShape
                            ]
                          },
                          [
                            block.settings.linear_image
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "hpc-linear__block",
                                    class: [
                                      "hpc-linear__block--" +
                                        _vm.schema.settings.imageShape
                                    ],
                                    attrs: { href: block.settings.linear_link }
                                  },
                                  [
                                    _c(
                                      "figure",
                                      {
                                        staticClass:
                                          "hpc-linear__block-content hpc-linear__block-content--rectangle bg-white"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "hpc-linear__block-image-wrapper"
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.imageSize(
                                                  block.settings.linear_image,
                                                  "x256"
                                                ),
                                                srcset: _vm.srcsetRectangle(
                                                  block.settings.linear_image
                                                ),
                                                alt: ""
                                              }
                                            })
                                          ]
                                        ),
                                        _c(
                                          "figcaption",
                                          {
                                            staticClass:
                                              "h7 color-black text-center"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                block.settings
                                                  .linear_collection_name
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }